import styled from 'styled-components';

export const EmptyWrapper = styled.div`
  height: 210px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: 992px) {
    height: 180px;
  }
`;
